import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

export const About = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="bg-[var(--ivory)] py-24 text-[var(--ink)] lg:py-36">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <Reveal><p className="label">{t.about.label}</p></Reveal>
        <div className="mt-10 grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <Reveal delay={0.05}>
              <h2 data-testid="about-title" className="font-display text-3xl font-light leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem]">{t.about.title}</h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-10 max-w-2xl text-base leading-relaxed text-[var(--muted)] md:text-lg">{t.about.body}</p>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2px]">
              <motion.img style={{ y, scale: 1.18 }} src="/img/warehouse.jpg" alt="Almacén de materiales" className="h-full w-full object-cover" />
              <div className="absolute inset-3 border border-[#f4f1ea]/50" />
            </div>
          </Reveal>
        </div>
        <div className="mt-20 grid border-t border-[#0e1420]/15 md:grid-cols-3">
          {t.about.pillars.map((p, i) => (
            <Reveal key={p.k} delay={i * 0.1}>
              <div data-testid={`about-pillar-${i}`} className="group h-full border-b border-[#0e1420]/15 py-10 md:border-b-0 md:border-r md:px-8 md:first:pl-0 md:last:border-r-0">
                <span className="font-mono text-xs text-[var(--gold-deep)]">0{i + 1}</span>
                <h3 className="mt-4 font-display text-2xl italic transition-transform duration-500 group-hover:translate-x-2">{p.k}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted)] md:text-base">{p.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
